// frontend/src/components/TerminalPanel.tsx
import React, { useEffect, useRef, useState } from 'react';
import { X, Square, Terminal } from 'lucide-react';

interface Props {
  output: string[];
  isRunning: boolean;
  onStop: () => void;
  onClear: () => void;
  onCommand: (cmd: string) => void; // <--- NEW PROP
}

export const TerminalPanel: React.FC<Props> = ({ output, isRunning, onStop, onClear, onCommand }) => {
  const scrollRef = useRef<HTMLDivElement>(null);
  const [input, setInput] = useState('');

  useEffect(() => {
    if (scrollRef.current) scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
  }, [output]);

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' && input.trim()) {
        onCommand(input);
        setInput('');
    }
  };

  return (
    <div className="terminal-container" style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <div className="terminal-header">
        <span style={{ borderBottom: '1px solid white', color: 'white', cursor: 'pointer' }}>Terminal</span>
        <div className="grow" />
        {isRunning && (
            <button onClick={onStop} className="btn" style={{ display: 'flex', alignItems: 'center', gap: '5px', color: '#f87171' }}>
                <Square size={10} fill="currentColor" /> Stop
            </button>
        )}
        <button onClick={onClear} className="btn"><X size={14}/></button>
      </div>

      <div ref={scrollRef} className="terminal-content">
        {output.map((line, i) => (
            <div key={i} dangerouslySetInnerHTML={{__html: line}} /> 
        ))}
      </div>

      {/* INPUT AREA */}
      <div style={{ display: 'flex', alignItems: 'center', padding: '5px 10px', borderTop: '1px solid #3e3e42', background: '#1e1e1e' }}>
          <Terminal size={12} style={{ marginRight: 8, color: '#007acc' }} />
          <input 
            type="text" 
            value={input}
            onChange={(e) => setInput(e.target.value)}
            onKeyDown={handleKeyDown}
            placeholder="Type 'pip install <package>' here..."
            style={{ 
                background: 'transparent', border: 'none', color: '#ccc', 
                flex: 1, fontFamily: 'monospace', fontSize: '13px', outline: 'none' 
            }}
          />
      </div>
    </div>
  );
};